import {NgModule} from '@angular/core';
import {AuthGuard} from './services/auth-guard.service';
import {CloudTokenAuthGuard} from './services/cloud-token-auth-guard.service';
import {CoordinatorGuard} from './services/coordinator-guard.service';
import {HomeGuard} from './services/home-guard.service';
import {CrmTokenAuthGuard} from './services/crm-token-auth-guard.service';
import {LoginGuard} from './services/login-guard.service';
import {PractitionerGuard} from './services/practitioner-guard.service';
import {SpecialistGuard} from './services/specialist-guard.service';
import {ClientGuard} from './services/client-guard.service';
import {AdminGuard} from '@core/guards/services/admin-guard.service';

@NgModule({
  providers: [
    AuthGuard,
    CloudTokenAuthGuard,
    CoordinatorGuard,
    CrmTokenAuthGuard,
    HomeGuard,
    LoginGuard,
    PractitionerGuard,
    SpecialistGuard,
    ClientGuard,
    AdminGuard
  ]
})
export class GuardsModule {
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/core/guards/guards.module.ts